export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-laugh-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line' },
  { slug: 'dongzuo', name: '动作片', icon: 'ri-fire-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-2-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
];

export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'kehuan',
    categoryName: '科幻片',
    year: 2026,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20for%20a%20Chinese%20sci-fi%20film%20featuring%20a%20giant%20space%20station%20and%20Earth%20in%20the%20background%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20blue%20tones%2C%20clean%20dark%20background%2C%20professional%20movie%20poster%20style%2C%20minimalist%20composition&width=400&height=560&seq=movie-01&orientation=portrait',
    description: '太阳即将膨胀吞噬地球，人类面临前所未有的生存危机。联合政府启动"流浪地球计划"，在地球表面建造上万座行星发动机，推动地球离开太阳系，开启长达2500年的星际流浪之旅。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
    duration: '148分钟',
    featured: true,
    hot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '封神第二部',
    category: 'dongzuo',
    categoryName: '动作片',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=A%20mythological%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20traditional%20armor%2C%20dramatic%20battle%20scene%2C%20golden%20and%20crimson%20tones%2C%20dark%20background%2C%20epic%20oriental%20mythology%20style%2C%20minimalist%20composition&width=400&height=560&seq=movie-02&orientation=portrait',
    description: '殷商末年，纣王暴虐无道，姜子牙携封神榜下山，辅佐周武王伐纣。一场人、仙、妖三界大战就此展开，封神大业谁主沉浮？',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适'],
    duration: '156分钟',
    featured: true,
    hot: false,
    isNew: true,
  },
  {
    id: 3,
    title: '长安三万里2',
    category: 'dongman',
    categoryName: '动漫',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%20depicting%20ancient%20Tang%20dynasty%20Changan%20cityscape%20with%20poets%20in%20traditional%20robes%2C%20warm%20golden%20sunset%20tones%2C%20ink%20wash%20painting%20style%20blended%20with%203D%2C%20dark%20background%2C%20elegant%20oriental%20aesthetic&width=400&height=560&seq=movie-03&orientation=portrait',
    description: '安史之乱后，大唐由盛转衰。李白与高适的命运再次交织，在乱世中坚守诗心，用笔墨书写不朽传奇。长安三万里，诗在，书在，长安就在。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    featured: true,
    hot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '热辣滚烫2',
    category: 'xiju',
    categoryName: '喜剧片',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20film%20poster%20with%20a%20confident%20woman%20boxer%20in%20the%20ring%2C%20vibrant%20red%20and%20warm%20lighting%2C%20inspiring%20and%20energetic%20mood%2C%20dark%20background%2C%20minimalist%20movie%20poster%20design&width=400&height=560&seq=movie-04&orientation=portrait',
    description: '乐莹经历了人生的大起大落后，重新踏上拳击之路。这一次，她不仅要战胜对手，更要战胜内心那个不自信的自己。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐'],
    duration: '135分钟',
    featured: false,
    hot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '深海2',
    category: 'dongman',
    categoryName: '动漫',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20animated%20film%20poster%20of%20a%20dreamlike%20underwater%20world%20with%20colorful%20jellyfish%20and%20coral%20reefs%2C%20magical%20particle%20effects%2C%20deep%20ocean%20blues%20contrasted%20with%20warm%20bioluminescent%20colors%2C%20dark%20background&width=400&height=560&seq=movie-05&orientation=portrait',
    description: '参宿再次坠入深海梦境，这次她遇到了新的伙伴。在奇幻瑰丽的水下世界中，她必须找到回家的路，同时揭开深海大饭店背后的秘密。',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文', '滕奎兴'],
    duration: '142分钟',
    featured: false,
    hot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '志愿军：存亡之战',
    category: 'dongzuo',
    categoryName: '动作片',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20war%20film%20poster%20with%20soldiers%20in%20battle%2C%20dramatic%20smoke%20and%20fire%2C%20heroic%20composition%2C%20dark%20and%20intense%20tones%2C%20epic%20cinematic%20style%2C%20minimalist%20movie%20poster%20design&width=400&height=560&seq=movie-06&orientation=portrait',
    description: '抗美援朝战争中，志愿军战士们以钢铁意志对抗强敌。在生死存亡的关键时刻，他们用血肉之躯筑起了保家卫国的钢铁长城。',
    director: '陈凯歌',
    cast: ['朱一龙', '张子枫', '辛柏青'],
    duration: '160分钟',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '繁花（剧版）',
    category: 'dianshiju',
    categoryName: '电视剧',
    year: 2026,
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20TV%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20vintage%20aesthetic%2C%20warm%20golden%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20dark%20background%2C%20sophisticated%20oriental%20style&width=400&height=560&seq=movie-07&orientation=portrait',
    description: '九十年代的上海，处处是机遇与挑战。阿宝在商海中沉浮，在黄河路上书写属于自己的传奇。霓虹闪烁的夜上海，人人都是繁花。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣'],
    duration: '30集',
    featured: true,
    hot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '庆余年2',
    category: 'dianshiju',
    categoryName: '电视剧',
    year: 2026,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20drama%20poster%20with%20a%20young%20man%20in%20traditional%20ancient%20Chinese%20robes%2C%20mysterious%20palace%20intrigue%20atmosphere%2C%20dark%20and%20rich%20golden%20accents%2C%20oriental%20period%20drama%20style&width=400&height=560&seq=movie-08&orientation=portrait',
    description: '范闲从北齐归来后，面临更加复杂的朝堂局势。二皇子谋反、神庙之谜、母亲的真相……一切谜团都将在这季揭晓。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明'],
    duration: '36集',
    featured: false,
    hot: true,
    isNew: true,
  },
  {
    id: 9,
    title: '飞驰人生3',
    category: 'xiju',
    categoryName: '喜剧片',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20racing%20comedy%20film%20poster%20with%20a%20rally%20car%20speeding%20on%20a%20desert%20track%2C%20dynamic%20motion%20blur%2C%20warm%20sunset%20tones%2C%20adventurous%20and%20humorous%20vibe%2C%20dark%20background&width=400&height=560&seq=movie-09&orientation=portrait',
    description: '张驰重返赛场后，面对新一代年轻车手的挑战。老将不死，只是逐渐凋零。这一次，他要证明年龄从来不是极限。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正'],
    duration: '132分钟',
    featured: false,
    hot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '地球脉动III',
    category: 'jilupian',
    categoryName: '纪录片',
    year: 2026,
    rating: 9.8,
    image: 'https://readdy.ai/api/search-image?query=A%20nature%20documentary%20poster%20with%20stunning%20wildlife%20photography%2C%20a%20majestic%20snow%20leopard%20in%20mountain%20landscape%2C%20breathtaking%20natural%20light%2C%20cinematic%20documentary%20style%2C%20dark%20background&width=400&height=560&seq=movie-10&orientation=portrait',
    description: '穿越七大洲，探索地球上最壮丽的自然奇观和最珍稀的野生动物。从极地冰原到热带雨林，每一帧都是视觉盛宴。',
    director: 'BBC Studios',
    cast: ['大卫·爱登堡'],
    duration: '8集',
    featured: false,
    hot: false,
    isNew: true,
  },
  {
    id: 11,
    title: '默杀2',
    category: 'kongbu',
    categoryName: '恐怖片',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20thriller%20film%20poster%20with%20a%20dark%20alleyway%20and%20a%20mysterious%20figure%20in%20shadow%2C%20cold%20blue-grey%20tones%2C%20suspenseful%20atmosphere%2C%20dark%20background%2C%20minimalist%20horror%20movie%20poster%20design&width=400&height=560&seq=movie-11&orientation=portrait',
    description: '一所女子中学接连发生离奇失踪案，警方介入调查后发现，每个失踪女生背后都藏着不为人知的秘密。真相远比想象的更加黑暗。',
    director: '柯汶利',
    cast: ['张钧甯', '王传君', '吴镇宇'],
    duration: '128分钟',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '王牌对王牌9',
    category: 'zongyi',
    categoryName: '综艺',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20celebrities%20in%20game%20show%20setting%2C%20vibrant%20and%20energetic%2C%20dark%20background%2C%20entertainment%20show%20style&width=400&height=560&seq=movie-12&orientation=portrait',
    description: '王牌家族再次集结！沈腾、贾玲领衔的欢乐阵容，带你感受最爆笑的游戏对决。经典游戏全新升级，欢笑不间断。',
    director: '浙江卫视',
    cast: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    duration: '12期',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 13,
    title: '我和我的家乡3',
    category: 'xiju',
    categoryName: '喜剧片',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20film%20poster%20about%20hometown%20stories%2C%20warm%20rural%20Chinese%20landscape%2C%20heartwarming%20and%20humorous%20tone%2C%20golden%20sunlight%2C%20dark%20background%2C%20minimalist%20movie%20poster&width=400&height=560&seq=movie-13&orientation=portrait',
    description: '五个关于家乡的温暖故事，五种不同的乡愁。从天山脚下到江南水乡，从东北雪原到岭南古镇，家乡的味道永远是最美的记忆。',
    director: '多位导演联合',
    cast: ['黄渤', '徐峥', '沈腾', '王宝强'],
    duration: '145分钟',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '星际穿越2',
    category: 'kehuan',
    categoryName: '科幻片',
    year: 2026,
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20film%20poster%20with%20a%20wormhole%20and%20distant%20galaxy%2C%20astronauts%20floating%20in%20space%2C%20cosmic%20scale%2C%20deep%20space%20blues%20and%20warm%20stellar%20light%2C%20dark%20background%2C%20epic%20cinematic&width=400&height=560&seq=movie-14&orientation=portrait',
    description: '人类在火星建立殖民地后，发现了一个通往更远星系的虫洞。新一代探险家们踏上穿越星际的旅程，寻找人类的新家园。',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
    duration: '169分钟',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '舌尖上的中国IV',
    category: 'jilupian',
    categoryName: '纪录片',
    year: 2026,
    rating: 9.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20food%20documentary%20poster%20with%20beautifully%20presented%20traditional%20Chinese%20dishes%2C%20steaming%20hot%20food%2C%20warm%20kitchen%20atmosphere%2C%20rich%20colors%2C%20dark%20background%2C%20appetizing%20food%20photography&width=400&height=560&seq=movie-15&orientation=portrait',
    description: '从田间到餐桌，从传统到创新。这一季带您走进中国饮食文化的深处，探寻食物背后的人情冷暖与时代变迁。',
    director: '陈晓卿',
    cast: ['李立宏'],
    duration: '10集',
    featured: false,
    hot: false,
    isNew: false,
  },
  {
    id: 16,
    title: '七夜雪',
    category: 'dianshiju',
    categoryName: '电视剧',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20romance%20drama%20poster%20with%20a%20couple%20in%20traditional%20ancient%20Chinese%20costumes%20in%20snow%2C%20cold%20winter%20tones%20with%20warm%20lantern%20light%2C%20dark%20background%2C%20romantic%20oriental%20aesthetic&width=400&height=560&seq=movie-16&orientation=portrait',
    description: '七夜飞雪，一世情长。药师谷少女薛紫夜与剑客霍展白在雪夜相遇，一段跨越生死的凄美爱情就此展开。',
    director: '李木戈',
    cast: ['迪丽热巴', '肖战', '王楚然'],
    duration: '40集',
    featured: false,
    hot: false,
    isNew: true,
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产电影，每一部都是王炸',
    excerpt: '随着中国电影工业的不断成熟，2026年将迎来一批制作精良、题材丰富的国产大片。从科幻巨制到现实主义佳作，这份片单值得每一位影迷收藏。',
    date: '2026-08-08',
    image: 'https://readdy.ai/api/search-image?query=A%20collage%20of%20Chinese%20movie%20posters%20arranged%20artistically%2C%20cinematic%20lighting%2C%20dark%20background%2C%20movie%20marathon%20theme%2C%20warm%20golden%20accents&width=800&height=450&seq=article-01&orientation=landscape',
    category: '影视资讯',
    content: `
      <h2>2026年中国电影市场展望</h2>
      <p>2026年，中国电影市场继续保持强劲增长态势。随着国产科幻、动画、现实题材电影的不断突破，观众对国产影片的信心达到了前所未有的高度。</p>
      
      <h3>1. 《流浪地球3》—— 科幻新纪元</h3>
      <p>作为中国科幻电影的标杆之作，《流浪地球》系列的第三部将带领观众进入更加宏大的宇宙叙事。郭帆导演表示，这一部将聚焦地球驶出太阳系后的全新挑战。</p>
      
      <h3>2. 《封神第二部》—— 神话史诗的续章</h3>
      <p>继第一部取得巨大成功后，《封神第二部》将展现更加宏大的仙魔大战。乌尔善导演用现代电影技术重新诠释了中国古典神话的魅力。</p>
      
      <h3>3. 《长安三万里2》—— 诗意大唐</h3>
      <p>追光动画的又一力作，延续了前作"新文化"系列的独特美学风格。李白的诗与远方，高适的家国情怀，将再次触动观众的心弦。</p>
      
      <h3>4. 《热辣滚烫2》—— 女性力量</h3>
      <p>贾玲导演的续作，延续了"爱自己"的主题，在喜剧的外壳下传递温暖与力量。这一次，乐莹的拳击之路将更加精彩。</p>
      
      <p>除此之外，《深海2》《志愿军：存亡之战》《飞驰人生3》等影片也备受期待。2026年，中国电影值得每一位观众走进影院。</p>
    `,
  },
  {
    id: 2,
    title: '《繁花》剧版收视长虹，王家卫的美学密码你读懂了吗？',
    excerpt: '从光影到构图，从台词到配乐，《繁花》的每一个画面都像一幅精心绘制的油画。本文带你深度解析王家卫在电视剧中的美学表达。',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20night%20scene%20with%20vintage%20neon%20lights%20in%201990s%20style%2C%20warm%20golden%20glow%2C%20nostalgic%20aesthetic%2C%20dark%20background%2C%20cinematic%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    category: '深度影评',
    content: `
      <h2>王家卫的电视剧处女作：一场视觉盛宴</h2>
      <p>当电影导演拍电视剧，会碰撞出怎样的火花？《繁花》给出了令人惊艳的答案。王家卫将他标志性的美学风格完美融入了电视剧的叙事节奏中。</p>
      
      <h3>光影的魔术</h3>
      <p>王家卫对光的运用堪称一绝。在《繁花》中，他大量使用了霓虹灯、路灯、室内暖光等多层次光源，营造出九十年代上海独特的氛围感。每一个场景的光影都经过精心设计，暗部浓重但不失细节，亮部温暖而不刺眼。</p>
      
      <h3>构图的匠心</h3>
      <p>黄金分割、框架式构图、镜面反射……这些在电影中常见的高级构图手法，被王家卫大量运用在《繁花》中。人物常常被门框、窗户、镜子切割或反射，暗示着角色的内心困境和复杂关系。</p>
      
      <h3>色彩的叙事</h3>
      <p>暖金色是《繁花》的主色调，象征着那个时代的繁华与迷离。而在情感高潮处，红色的大胆使用则强化了戏剧张力。王家卫用色彩讲述故事，让观众在视觉享受中感受角色的情感变化。</p>
      
      <h3>节奏的诗意</h3>
      <p>慢镜头、留白、环境音……王家卫的节奏把控让《繁花》具有了诗歌般的韵律感。在快节奏的商战戏之外，那些缓慢流淌的生活片段，才是这部剧最动人的部分。</p>
      
      <p>《繁花》不只是一部电视剧，它是一封写给上海的情书，也是王家卫美学理念的集大成之作。</p>
    `,
  },
  {
    id: 3,
    title: '国产动漫崛起之路：从《大圣归来》到《长安三万里》',
    excerpt: '十年磨一剑，国产动漫从追赶者变成了引领者。回顾国产动画电影的发展历程，我们能看到中国动画人不懈的坚持与创新。',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20evolution%20showcasing%20different%20art%20styles%20from%20traditional%20ink%20wash%20to%20modern%203D%2C%20colorful%20characters%2C%20dark%20background%2C%20cinematic%20presentation&width=800&height=450&seq=article-03&orientation=landscape',
    category: '行业观察',
    content: `
      <h2>中国动画电影的黄金十年</h2>
      <p>2015年，《大圣归来》以9.56亿票房宣告了国产动画电影的回归。十年后的今天，国产动画已经发展成为中国电影市场不可忽视的重要力量。</p>
      
      <h3>技术突破：从追随到引领</h3>
      <p>《深海》的"粒子水墨"技术、《长安三万里》的古风三维渲染、《哪吒之魔童降世》的动作设计……国产动画在技术上已经达到了国际一流水平。更令人欣喜的是，这些技术不是简单的模仿，而是融入了中国独特的美学理念。</p>
      
      <h3>题材创新：讲好中国故事</h3>
      <p>从神话改编到历史演绎，从现实题材到科幻想象，国产动画的题材日益丰富。《雄狮少年》关注留守少年成长，《深海》探讨心理健康，《长安三万里》重现盛唐风华——这些作品证明，动画不只是儿童的艺术。</p>
      
      <h3>产业成熟：全产业链布局</h3>
      <p>追光动画、彩条屋、十月文化……一批专业的动画公司成长起来，形成了从创意开发、制作到宣发的完整产业链。人才储备、技术积累、市场认可度都达到了新的高度。</p>
      
      <p>国产动漫的崛起不是偶然，而是中国动画人数十年如一日的坚持与努力的结果。未来，我们有理由期待更多优秀的国产动画作品。</p>
    `,
  },
  {
    id: 4,
    title: '《庆余年2》热度破圈，古装剧的破局之道在哪里？',
    excerpt: '《庆余年2》凭借精良的制作和扎实的剧本，在众多古装剧中脱颖而出。它的成功给整个行业带来了哪些启示？',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20scene%20with%20intricate%20costumes%20and%20lighting%2C%20mysterious%20atmosphere%2C%20dark%20background%2C%20cinematic%20oriental%20aesthetic&width=800&height=450&seq=article-04&orientation=landscape',
    category: '深度影评',
    content: `
      <h2>《庆余年2》凭什么火了？</h2>
      <p>在古装剧扎堆的当下，《庆余年2》能够脱颖而出，靠的到底是什么？答案可能比你想象的更简单——好剧本、好演员、好制作。</p>
      
      <h3>剧本为王</h3>
      <p>《庆余年》系列最成功的地方在于对原著的尊重与改编的智慧。编剧没有简单地照搬小说，而是提炼出最精彩的情节线，同时保持了对权谋、人性的深度思考。这种"严肃喜剧"的调性，让不同年龄段的观众都能找到共鸣。</p>
      
      <h3>演员的化学反应</h3>
      <p>张若昀的范闲、陈道明的庆帝、吴刚的陈萍萍……每个角色都找到了最合适的演员。新生代与老戏骨的同台飙戏，产生了奇妙的化学反应。</p>
      
      <h3>制作的用心</h3>
      <p>从服化道到场景设计，从配乐到色调，《庆余年2》在制作层面的每一个细节都经得起推敲。这种全方位的品质把控，是古装剧破局的关键。</p>
      
      <p>古装剧市场不缺数量，缺的是质量。《庆余年2》的成功证明，只要用心做好内容，观众自然会用脚投票。</p>
    `,
  },
];

export const faqItems = [
  {
    question: '嫩草影院需要注册才能观看吗？',
    answer: '不需要！嫩草影院坚持免费开放的原则，所有影视内容均可直接在线观看，无需注册、无需登录，打开网站即可享受流畅的观影体验。',
  },
  {
    question: '嫩草影院支持哪些设备观看？',
    answer: '嫩草影院全面支持电脑、平板、手机等多种设备。无论是在家中用大屏电脑观看，还是出门在外用手机追剧，都能获得流畅的观影体验。我们采用响应式设计，自动适配不同屏幕尺寸。',
  },
  {
    question: '嫩草影院的影片画质如何？',
    answer: '我们提供高清乃至超清画质的影片资源，支持1080P和4K分辨率。同时采用先进的视频编码技术，在保证画质的前提下优化带宽使用，让您即使在没有高速网络的环境下也能流畅观看。',
  },
  {
    question: '嫩草影院的影片更新频率是怎样的？',
    answer: '我们每天都会更新最新的电影、电视剧、动漫和综艺内容。热门新片上映后，我们的团队会在第一时间为您提供观看资源，确保您不会错过任何精彩内容。',
  },
  {
    question: '在嫩草影院观看影片会产生费用吗？',
    answer: '完全免费！嫩草影院承诺所有内容永久免费观看。我们通过广告等方式维持运营，不会向用户收取任何费用。您可以放心观看，无需担心任何隐藏收费。',
  },
  {
    question: '嫩草影院的影片资源是否正版？',
    answer: '嫩草影院致力于为用户提供优质的影视内容。我们严格遵守相关法律法规，与多家版权方保持合作。如您发现任何侵权内容，请通过"关于我们"页面的联系方式告知我们，我们将及时处理。',
  },
];

export const testimonials = [
  {
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20male%20portrait%20avatar%2C%20warm%20smile%2C%20professional%20headshot%2C%20clean%20neutral%20background%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '嫩草影院真的是我每天必刷的网站！片源更新特别快，画质也很清晰。最重要的是完全免费，不用注册就能看，太方便了。强烈推荐给所有喜欢看电影的朋友！',
    rating: 5,
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20female%20portrait%20avatar%2C%20gentle%20smile%2C%20professional%20headshot%2C%20clean%20neutral%20background%2C%20soft%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '作为一个资深追剧党，嫩草影院的电视剧资源真的太全了！《繁花》《庆余年2》这些热播剧都能第一时间看到。分类也很清晰，找剧特别方便。',
    rating: 5,
  },
  {
    name: '张同学',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20portrait%20avatar%2C%20bright%20smile%2C%20casual%20headshot%2C%20clean%20neutral%20background%2C%20soft%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '动漫区的资源太给力了！《长安三万里》《深海》这些国产动画都能看，画质超棒。还有好多日本动漫也有，追番神器！',
    rating: 5,
  },
];